import ApiClient from './ApiClient';

class CityAudiosAPI extends ApiClient {
  constructor() {
    super('city_audios', { accountScoped: true });
  }
}

export default new CityAudiosAPI();
